export const fr = {
  nav: {
    services: "Services",
    references: "Références",
    about: "À propos",
    faq: "FAQ",
    tools: "Outils",
    contact: "Contact",
    cta: "Prendre RDV",
  },
  common: {
    available: "Disponible pour nouveaux mandats Q2 2026",
    learnMore: "En savoir plus",
    discoverServices: "Découvrir nos services",
    bookCall: "CONTACTEZ NOUS",
    bookSlot: "CONTACTEZ NOUS",
    talk: "Discuter de votre besoin",
    seeAllRefs: "Voir toutes les références",
    moreAboutAlex: "EN SAVOIR PLUS",
    followLinkedIn: "NOUS SUIVRE SUR LINKEDIN",
    sendEmail: "ENVOYER\nUN EMAIL",
    call: "Appeler",
    send: "Envoyer",
  },
  breadcrumb: {
    home: "Accueil",
  },
  home: {
    title: "Consultant hôtelier · Ouverture & gestion | 2AM Hospitality",
    description:
      "Consultant hôtelier indépendant en Belgique & Luxembourg : ouverture, préouverture, gestion d'hôtel, short-stay et hôtellerie hybride.",
    heroTitlePre: "L'hôtellerie, ",
    heroTitleAccent: "structurée.",
    heroTitlePost: "\nDe la préouverture à l'efficacité opérationnelle.",
    heroSub:
      "Consultant et exploitant hôtelier belge, nous accompagnons hôtels indépendants, boutique-hôtels et concepts hybrides — de la pré-ouverture à l'optimisation quotidienne.",
    seoLead:
      "Consultant hôtelier indépendant — ouverture, préouverture, gestion et management d'hôtel. Exploitant short-stay et hôtellerie hybride en Belgique et au Luxembourg.",
    stats: [
      { v: "15+", l: "années d'expérience" },
      { v: "40+", l: "établissements accompagnés" },
      { v: "2", l: "pays (Belgique & Luxembourg)" },
      { v: "100%", l: "indépendant" },
    ],
    statsSubtext: [
      "en exploitation hôtelière opérationnelle",
      "de 15 à 450 chambres, BE & LU",
      "Belgique & Luxembourg",
      "depuis 2022",
    ],
    offersTitle: "Trois axes d'accompagnement",
    offersSub:
      "Un spectre complet pour répondre à vos enjeux, du ponctuel à l'opérationnel.",
    offers: [
      {
        title: "Gestion des opérations",
        desc: "Exploitation quotidienne, pré-ouverture et ouverture. Pilotage terrain ou à distance, mise en place des standards, structuration des équipes et des process.",
        tags: ["Pré-ouverture", "Ouverture", "Exploitation"],
      },
      {
        title: "Consulting ponctuel",
        desc: "Audits flash et missions ciblées pour améliorer vos opérations : diagnostic, plan d'action concret, mesure des résultats.",
        tags: ["Audit", "Plan d'action", "ROI"],
      },
      {
        title: "Permis, IT & automatisation",
        desc: "Permis d'exploitation, écosystème IT hôtelier et automatisation des process. \nL'expertise technique qui libère vos équipes.",
        tags: ["Permis", "IT hôtelière", "Automatisation"],
      },
    ],
    methodTitle: "Une méthode claire, des résultats mesurables.",
    method: [
      { t: "Écouter", d: "On comprend votre contexte, vos contraintes, vos objectifs." },
      { t: "Diagnostiquer", d: "Audit opérationnel, financier, technique. Chiffré, factuel." },
      { t: "Agir", d: "Plan d'action priorisé. Exécution terrain ou accompagnement équipes." },
      { t: "Mesurer", d: "KPIs clairs, reporting régulier, ajustements continus." },
    ],
    forWhoTitle: "Avec qui travaillons-nous ?",
    forWho: [
      "Hôtels indépendants",
      "Boutique-hôtels",
      "Petits groupes hôteliers en structuration",
      "Short-stay et exploitation short-stay",
      "Hôtellerie hybride (aparthotel, coliving-hôtel)",
      "De l'économique à l'expérientiel",
    ],
    refsTitle: "Ils nous font confiance",
    aboutTeaserTitle: "10 ans sur le terrain. Pas en salle de réunion.",
    aboutTeaser:
      "Nous avons structuré, ouvert et redressé des hôtels pendant 10 ans. \nAvec 2AM Hospitality, nous mettons cette expertise au service des opérateurs qui veulent des résultats concrets et mesurables.",
    finalTitle: "Un projet, une question, un audit ?",
    finalSub: "​",
    manifestoTitle: ["Quand le lobby ", "devient calme,", "nous sommes réveillés."],
    manifestoDesc:
      "2AM est l'heure où le night auditor clôture la journée et où les clients dorment. \nC'est aussi l'heure où chaque décision opérationnelle peut être prise — en revenus, en expérience client, en marge.",
    readMore: "Lire toute l'histoire",
  },
  services: {
    title: "Services consultant hôtelier — Belgique & Luxembourg",
    description:
      "Ouverture & préouverture d'hôtel, gestion, short-stay et hôtellerie hybride. Permis et IT hôtelière en Belgique & Luxembourg.",
    h1: "Consultant hôtelier & exploitant d'établissement",
    sub: "Trois axes, une méthode, des résultats mesurables.",
    tldr: "2AM Hospitality est un cabinet belge de consultance et d'exploitation hôtelière, spécialisé dans l'ouverture, la préouverture, la gestion et le management d'hôtel — y compris short-stay et hôtellerie hybride en Belgique et au Luxembourg.",
    tldrLabel: "En 1 phrase",
    modality: "Modalités",
    modalityValue: "Mission au forfait, en régie, ou retainer mensuel.",
    forWho: "Pour qui ?",
    concretely: "Ce que nous faisons concrètement",
    whyTitle: "Pourquoi 2AM ?",
    why: [
      { e: "🎯", t: "Terrain d'abord", d: "Nous avons exploité des hôtels, pas seulement conseillé." },
      { e: "📊", t: "Chiffré et livrable", d: "Pas de deck, des KPIs et des actions concrètes." },
      { e: "⚙️", t: "Double culture", d: "Exploitation + tech + permis sous un même toit." },
      { e: "📍", t: "Ancré en Belgique", d: "Connaissance du marché, des réglementations et des acteurs locaux." },
    ],
    tableTitle: "Comparatif des trois offres",
    tableHeaders: ["", "Gestion des opérations", "Consulting ponctuel", "Permis & IT"],
    tableRows: [
      { l: "Durée typique", v: ["3 à 12 mois", "2 à 30 jours", "1 à 6 mois"] },
      { l: "Format", v: ["Forfait ou retainer", "Forfait", "Forfait ou régie"] },
      { l: "Livrables", v: ["Reporting KPIs, SOPs, standards", "Plan d'action priorisé", "Dossier permis, stack IT configuré"] },
      { l: "Idéal pour", v: ["Pré-ouverture, reprise, optimisation continue", "Diagnostic flash, redressement", "Nouvelles ouvertures, refonte IT"] },
    ],
    miniFaqTitle: "Questions fréquentes sur nos services",
    miniFaq: [
      {
        q: "Quelle est la différence entre un audit flash et un accompagnement opérationnel ?",
        a: "L'audit flash (2 à 5 jours) produit un diagnostic chiffré et un plan d'action. L'accompagnement opérationnel, c'est l'exécution de ce plan, sur plusieurs mois, avec présence terrain ou pilotage à distance.",
      },
      {
        q: "Peut-on combiner plusieurs services ?",
        a: "Oui. La plupart de nos missions combinent un audit initial (consulting ponctuel) suivi d'un accompagnement à l'exécution (gestion des opérations). Nous adaptons le périmètre après le premier appel de cadrage.",
      },
      {
        q: "Intervenez-vous uniquement en Belgique ?",
        a: "Notre cœur de marché est la Belgique et le Luxembourg. Nous acceptons des missions ponctuelles dans le reste de l'Europe selon disponibilité.",
      },
    ],
    faqLinkTitle: "Vous avez d'autres questions ?",
    faqLinkText: "Tarifs, délais, modalités : consultez notre FAQ complète.",
    faqLinkCta: "Consulter la FAQ",
    shortStayTitle: "Exploitant et consultant short-stay · hôtellerie hybride",
    shortStayDesc:
      "Au-delà de l'hôtel classique, nous accompagnons les opérateurs short-stay (séjours courts, aparthotels) et les concepts d'hôtellerie hybride (coliving-hôtel, aparthotel-coworking). Structuration de l'exploitation, conformité réglementaire belge, stack PMS adapté aux séjours longs et automatisation du parcours client sans réception 24/7.",
    shortStayBullets: [
      "Exploitant short-stay : process, équipes lean, distribution multi-canal",
      "Hôtellerie hybride : modèles aparthotel, coliving-hôtel, hôtel-coworking",
      "Conformité spécifique short-stay (Bruxelles, Wallonie, Flandre, Luxembourg)",
      "Automatisation : check-in online, serrures connectées, conciergerie digitale",
    ],
    items: [
      {
        id: "operations",
        num: "01",
        title: "Gestion des opérations",
        intro:
          "De la pré-ouverture au pilotage opérationnel quotidien. Présence terrain ou management à distance, selon votre besoin.",
        tldr:
          "En 1 phrase : nous prenons en charge la pré-ouverture et le management opérationnel d'hôtels indépendants, boutique-hôtels et petits groupes en Belgique & Luxembourg, sur le terrain ou à distance, avec SOPs, reporting KPIs et pilotage des équipes.",
        bullets: [
          "Accompagnement pré-ouverture : planning, recrutement, formation, achats",
          "Pilotage de l'ouverture (soft opening + grand opening)",
          "Management opérationnel intérim",
          "Structuration des standards et SOPs",
          "Mise en place du reporting opérationnel quotidien",
          "Gestion des équipes et plannings",
          "Coordination avec partenaires (blanchisserie, F&B, maintenance)",
        ],
        tags: ["Hôtels indépendants", "Boutique-hôtels", "Petits groupes"],
      },
      {
        id: "consulting",
        num: "02",
        title: "Consulting ponctuel sur l'amélioration des opérations",
        intro:
          "Une mission courte, ciblée, chiffrée. Diagnostic terrain, plan d'action priorisé, KPIs de suivi.",
        tldr:
          "En 1 phrase : audit flash de 2 à 5 jours sur site avec diagnostic financier, mystery visit et plan d'action priorisé chiffré pour redresser ou optimiser un hôtel en exploitation, à partir de 4 500 € HT.",
        bullets: [
          "Audit opérationnel flash (2-5 jours terrain)",
          "Diagnostic financier et benchmarking",
          "Revue des process front-office et housekeeping",
          "Plan d'action priorisé avec KPIs",
          "Mystery visit et analyse parcours client",
          "Recommandations distribution et revenue management",
          "Suivi mensuel d'exécution (optionnel)",
        ],
        tags: ["Hôtels en exploitation", "Groupes en structuration"],
      },
      {
        id: "tech",
        num: "03",
        title: "Consulting ciblé : permis, IT & automatisation",
        intro:
          "L'expertise technique qui libère les équipes : conformité réglementaire, stack IT moderne, automatisation des flux.",
        tldr:
          "En 1 phrase : nous montons les dossiers de permis d'exploitation BE/LU, sélectionnons et intégrons la stack PMS (Mews, Cloudbeds, Mistеrbooking, Hotellab) et automatisons check-in, serrures connectées et conciergerie pour les ouvertures et concepts hybrides.",
        bullets: [
          "Accompagnement demande et renouvellement permis d'exploitation",
          "Contrôle de la conformité réglementaire",
          "Audit et refonte infrastructure IT hôtelière (PMS, channel manager, wifi, TV, serrures connectées)",
          "Sélection et intégration du bon stack tech (PMS & Suite IT globale)",
          "Automatisation : check-in online, upsell, conciergerie digitale, connecteurs comptables",
        ],
        tags: ["Pré-ouverture", "Hôtels en transformation", "Concepts hybrides"],
      },
    ],
  },
  references: {
    title: "Références consultant hôtelier — 2AM Hospitality",
    description:
      "Missions de consultant hôtelier en Belgique : ouvertures, exploitation, short-stay et hôtellerie hybride. Boutique-hôtels et aparthotels.",
    h1: "Missions d'ouverture, préouverture, gestion et management d'hôtel",
    sub: "Quelques missions récentes",
    typesTitle: "Types d'établissements accompagnés",
    types: [
      "Hôtels indépendants",
      "Boutique-hôtels",
      "Groupes économiques",
      "Short-stay & aparthotels",
      "Concepts hybrides",
    ],
    items: [
      {
        type: "Boutique-hôtel 4★ · 45 chambres · Bruxelles",
        mission: "Accompagnement pré-ouverture",
        duration: "6 mois · 2024-2025",
        results: [
          "Recrutement et formation de l'équipe complète",
          "Mise en place du PMS et stack distribution",
          "Ouverture dans les délais avec TripAdvisor 4.7 dès le 1er mois",
        ],
        tag: "Opérations",
      },
      {
        type: "Groupe 3 hôtels · Luxembourg",
        mission: "Audit opérationnel & plan d'action",
        duration: "3 mois · 2024",
        results: [
          "Diagnostic terrain sur les 3 sites",
          "Plan d'action priorisé sur 12 leviers",
          "+11 pts de marge brute opérationnelle sur 6 mois",
        ],
        tag: "Consulting",
      },
      {
        type: "Aparthotel hybride · Belgique",
        mission: "Refonte IT & automatisation",
        duration: "4 mois · 2025",
        results: [
          "Migration vers stack PMS cloud moderne",
          "Check-in 100% online + serrures connectées",
          "−40% de temps administratif par séjour",
        ],
        tag: "Tech",
      },
    ],
    cta: "Vous voulez en discuter ?",
  },
  about: {
    title: "À propos · Alexandre Dufrene — 2AM Hospitality",
    description:
      "Alexandre Dufrene, fondateur de 2AM Hospitality. 10 ans d'exploitation hôtelière (B&B HOTELS, ACCOR) au service des opérateurs.",
    h1: "10 ans sur le terrain. \nPas en salle de réunion.",
    sub: "Alexandre Dufrene — consultant hôtelier, exploitant short-stay et hôtellerie hybride en Belgique & Luxembourg.",
    bio: "Après plusieurs années à piloter des ouvertures et des reprises d'hôtels pour une chaîne hôtelière et des groupes indépendants, Alexandre Dufrene fonde 2AM Hospitality en 2022 avec une conviction : les hôteliers indépendants méritent un accompagnement aussi rigoureux que celui des grands groupes, sans la bureaucratie. \n\nSa double culture — exploitation terrain et développement de portefeuille — lui permet de parler aussi bien aux équipes réception qu'aux investisseurs et propriétaires. \n\n10 ans de terrain. Des résultats mesurables.",
    tldr: "2AM Hospitality vous accompgne sur vos projets hôteliers et l'exploitant short-stay ou hôtellerie hybride en Belgique & Luxembourg.",
    servicesCtaTitle: "Envie de voir comment nous travaillons ?",
    servicesCta: "Découvrir nos services",
    journeyTitle: "Parcours",
    journey: [
      { y: "2022", t: "Création de 2AM Hospitality" },
      { y: "2019-2022", t: "Opérations multi-sites · B&B HOTELS" },
      { y: "2009-2019", t: "Management hôtelier · groupes indépendants" },
    ],
    whyTitle: "Pourquoi 2AM ?",
    why: "2AM, c'est l'heure où un hôtel vit sans filtre, où tout le monde dors mais que tout se joue. \n\nC'est grace à l'anticipation que la qualité d'exploitation se mesure vraiment.",
    valuesTitle: "Valeurs",
    values: [
      { t: "Concret", d: "Du terrain, du chiffré, du livrable. Pas de slide creuse." },
      { t: "Smart", d: "Automatisation des tâches pour libérer du temps à valeur ajoutée aux équipes" },
      { t: "Mesurable", d: "Des KPIs définis avant la mission, mesurés après." },
    ],
  },
  faq: {
    title: "FAQ consultant hôtelier — Belgique & Luxembourg",
    description:
      "Tarifs, délais, modalités, PMS, zone d'intervention : réponses aux questions fréquentes sur la consultance hôtelière en Belgique.",
    h1: "FAQ — consultant hôtelier, ouverture & exploitation",
    glossaryTitle: "Glossaire — termes clés",
    glossary: [
      { term: "Hôtellerie hybride", def: "Concept mêlant hôtel, aparthotel, coliving ou coworking au sein d'un même établissement. Réception réduite, séjours courts ou longs, parcours client digitalisé." },
      { term: "Short-stay", def: "Exploitation de logements meublés pour des séjours courts (1 à 30 nuits), en complément ou en alternative à l'hôtellerie classique. Cadre réglementaire spécifique à Bruxelles, Wallonie, Flandre et Luxembourg." },
      { term: "Préouverture (pre-opening)", def: "Phase de 6 à 12 mois précédant l'ouverture commerciale d'un hôtel : recrutement, formation, achats, mise en place du PMS, soft opening." },
      { term: "PMS (Property Management System)", def: "Logiciel central d'exploitation hôtelière (réservations, check-in, facturation, reporting). Exemples : Mews, Cloudbeds, Mister­booking, Apaleo, Opera Cloud." },
    ],
    items: [
      {
        q: "Quelle est votre zone d'intervention ?",
        a: "Belgique et Luxembourg en priorité, avec déplacements ponctuels en Europe. Basés à Incourt, nous intervenons fréquemment à Bruxelles, Anvers, Gand, Liège, Luxembourg-Ville et leurs régions.",
      },
      {
        q: "Combien coûte une mission type ?",
        a: "Un audit flash démarre à 4 500 € HT (2 à 5 jours). Un accompagnement pré-ouverture varie de 25 000 € à 80 000 € selon le périmètre. Un retainer mensuel d'optimisation : 2 500 à 6 000 € HT/mois. Devis sur mesure après cadrage.",
      },
      {
        q: "Travaillez-vous au forfait ou en régie ?",
        a: "Les deux. Au forfait pour les missions cadrées (audits, ouvertures), en régie pour le management intérim ou les besoins évolutifs. Le retainer mensuel est privilégié pour le suivi continu.",
      },
      {
        q: "Proposez-vous des missions d'intérim management ?",
        a: "Oui, en direction d'hôtel ou direction opérationnelle multi-sites, sur des durées de 1 à 6 mois.",
      },
      {
        q: "Quelle est la durée minimale d'une mission ?",
        a: "2 jours pour un audit flash. Pas de durée maximale.",
      },
      {
        q: "Comment se déroule une mission de pré-ouverture ?",
        a: "Cadrage initial, planning détaillé J-180 à J+30, recrutement, formation, mise en place des process, soft opening, grand opening, puis transfert structuré aux équipes en place.",
      },
      {
        q: "Travaillez-vous avec les indépendants ou uniquement les groupes ?",
        a: "Les deux. Notre cœur de cible : indépendants, boutique-hôtels et petits groupes en structuration. Du segment économique à l'expérientiel.",
      },
      {
        q: "Avez-vous une expertise sur les permis d'exploitation en Belgique et au Luxembourg ?",
        a: "Oui : permis d'exploitation, sécurité incendie, AFSCA, urbanisme, déclarations communales. Nous travaillons avec un réseau d'avocats spécialisés pour les dossiers complexes.",
      },
      {
        q: "Quels PMS maîtrisez-vous ?",
        a: "Mews, Cloudbeds, Hotellab, Apaleo, Opera Cloud, Misterbooking, ainsi que les channel managers (SiteMinder, D-EDGE, Cubilis) et les outils de revenue management.",
      },
      {
        q: "Comment démarrer une collaboration ?",
        a: "Un call découverte de 30 minutes (gratuit, sans engagement) via Calendly, ou un email à hello@2amhospitality.com. Nous revenons sous 48h avec un cadrage et une proposition.",
      },
      {
        q: "Accompagnez-vous des projets de short-stay et d'hôtellerie hybride ?",
        a: "Oui. Nous intervenons sur des opérations short-stay (séjours courts, aparthotels) et des concepts d'hôtellerie hybride (coliving-hôtel, aparthotel-coworking) : structuration de l'exploitation, conformité réglementaire belge et luxembourgeoise, stack PMS adapté, automatisation du parcours client (check-in online, serrures connectées).",
      },
      {
        q: "Quelle différence entre un consultant hôtelier et un exploitant hôtelier ?",
        a: "Un consultant hôtelier conseille, audite et structure ; un exploitant hôtelier pilote l'opération au quotidien. 2AM Hospitality combine les deux : nous avons exploité des hôtels pendant 10 ans avant de conseiller — d'où des recommandations directement applicables sur le terrain et la possibilité de prendre la direction opérationnelle en intérim.",
      },
    ],
  },
  contact: {
    title: "Contact 2AM Hospitality — consultant hôtelier",
    description:
      "Contactez 2AM Hospitality : prise de rendez-vous, email, téléphone. Bruxelles · Belgique · Luxembourg.",
    h1: "Parlons-en.",
    sub: "Discutons de votre projet : ouverture d'hôtel, management, exploitation short-stay ou hôtellerie hybride.",
    bookTitle: "Prendre RDV",
    bookDesc: "Réservez directement un créneau de 30 min.",
    emailTitle: "Email",
    phoneTitle: "Téléphone",
    formTitle: "Ou envoyez-nous un message",
    faqLinkText: "Des questions avant de nous écrire ?",
    faqLinkCta: "Consulter la FAQ",
    responseGuarantee: "Réponse garantie sous 24h ouvrées",
    fields: {
      name: "Nom complet",
      email: "Email",
      company: "Entreprise / projet",
      type: "Type de demande",
      typeOptions: ["Opérations", "Consulting ponctuel", "Tech & Permis", "Autre"],
      message: "Message",
      gdpr: "J'accepte que mes données soient utilisées pour répondre à ma demande.",
    },
    success: "Merci, votre message a bien été envoyé.",
  },
  footer: {
    pitch:
      "Consultant et exploitant hôtelier belge, nous accompagnons hôtels indépendants, boutique-hôtels et concepts hybrides.",
    nav: "Navigation",
    services: "Services",
    contact: "Contact",
    legal: "Mentions légales",
    privacy: "Politique de confidentialité",
    cookies: "Cookies",
    rights: "Tous droits réservés.",
  },
  related: {
    eyebrow: "À explorer",
    title: "Pour aller plus loin",
    cta: "Découvrir",
    cards: {
      services: {
        title: "Services de consultance hôtelière",
        desc: "Ouverture, gestion, management d'hôtel et hôtellerie hybride.",
      },
      references: {
        title: "Missions récentes",
        desc: "Cas concrets : ouvertures, audits, exploitation, short-stay.",
      },
      about: {
        title: "Le fondateur",
        desc: "Alexandre Dufrene — 10 ans d'exploitation hôtelière en Belgique.",
      },
      faq: {
        title: "FAQ",
        desc: "Tarifs, délais, périmètre, PMS maîtrisés : toutes les réponses.",
      },
      tools: {
        title: "Outils hôteliers",
        desc: "Calculateurs et ressources gratuits pour opérateurs hôteliers.",
      },
      contact: {
        title: "Contact & RDV",
        desc: "Call découverte 30 min, email ou téléphone — réponse sous 24h.",
      },
    },
  },
  cookies: {
    banner: {
      title: "Vos préférences cookies",
      body: "Nous utilisons des cookies pour assurer le bon fonctionnement du site et, avec votre accord, mesurer son audience. Vous pouvez accepter, refuser ou personnaliser à tout moment.",
      learnMore: "En savoir plus",
      acceptAll: "Tout accepter",
      rejectAll: "Tout refuser",
      customize: "Personnaliser",
    },
    prefs: {
      title: "Préférences cookies",
      subtitle: "Choisissez les catégories que vous autorisez.",
      save: "Enregistrer mes choix",
      close: "Fermer",
    },
    cats: {
      necessary: {
        title: "Strictement nécessaires",
        desc: "Indispensables au fonctionnement du site (sécurité, préférences de langue, navigation). Toujours actifs.",
      },
      analytics: {
        title: "Mesure d'audience",
        desc: "Statistiques anonymisées (Google Analytics) pour comprendre l'usage du site et l'améliorer.",
      },
      marketing: {
        title: "Marketing",
        desc: "Cookies publicitaires ou de réseaux sociaux. Aucun n'est actif aujourd'hui — réservé pour un usage futur.",
      },
    },
    page: {
      eyebrow: "Politique cookies",
      title: "Politique de gestion des cookies",
      intro:
        "Cette page explique quels cookies et technologies similaires sont utilisés sur 2amhospitality.com, et comment vous pouvez gérer vos préférences à tout moment.",
      manageTitle: "Gérer mes préférences",
      manageBody:
        "Vous pouvez modifier vos choix à tout moment. Cela rouvrira la fenêtre de préférences.",
      manageCta: "Modifier mes préférences",
      sections: [
        {
          title: "Qu'est-ce qu'un cookie ?",
          body: "Un cookie est un petit fichier texte déposé sur votre appareil lors de la visite d'un site web. Il permet, par exemple, de se souvenir de votre langue, d'assurer la sécurité d'une session ou de mesurer l'audience du site.",
        },
        {
          title: "Cookies strictement nécessaires",
          body: "Ces cookies sont indispensables au fonctionnement du site : préférence de langue, sécurité, équilibrage de charge. Ils ne nécessitent pas votre consentement et ne peuvent pas être désactivés.",
        },
        {
          title: "Cookies de mesure d'audience",
          body: "Avec votre accord, nous utilisons Google Analytics pour mesurer la fréquentation du site de manière anonymisée (IP anonymisée, pas de croisement avec d'autres services). Ces données nous aident à améliorer le contenu et l'ergonomie.",
        },
        {
          title: "Cookies marketing",
          body: "Aucun cookie publicitaire n'est déposé à ce jour. Cette catégorie est réservée à un usage futur (par exemple un pixel LinkedIn) et restera désactivée tant que vous ne l'aurez pas explicitement autorisée.",
        },
        {
          title: "Durée de conservation",
          body: "Votre choix de consentement est conservé 12 mois dans votre navigateur. Au-delà, la fenêtre de consentement réapparaîtra.",
        },
        {
          title: "Vos droits",
          body: "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition concernant vos données. Pour exercer ces droits, contactez-nous à hello@2amhospitality.com.",
        },
      ],
    },
  },
  tools: {
    title: "Outils hôteliers — 2AM Hospitality",
    description:
      "Découvrez les outils et plateformes développés ou soutenus par 2AM Hospitality : Onerly, Maintel.io, Groupsmadeeasy.",
    eyebrow: "Outils",
    h1: "Outils du consultant et exploitant hôtelier",
    sub: "Plateformes que nous développons ou soutenons pour l'ouverture d'hôtel, le management hôtel, le short-stay et l'hôtellerie hybride.",
    statusLive: "En ligne",
    statusWip: "En développement",
    visit: "Visiter le site",
    wipNote: "Disponible prochainement",
    items: [
      {
        name: "Onerly",
        tagline: "​",
        description:
          "Plateforme dédiée à la mise en valeur des projets hôteliers et concepts indépendants accompagnés.",
        status: "live",
        url: "#",
      },
      {
        name: "Maintel.io",
        tagline: "​",
        description:
          "Solution de gestion technique et de maintenance pensée pour les établissements hôteliers exigeants.",
        status: "live",
        url: "#",
      },
      {
        name: "Groupsmadeeasy",
        tagline: "En cours de développement",
        description:
          "Outil de gestion des réservations groupes pour hôteliers, en cours de conception. Lancement prévu prochainement.",
        status: "wip",
        url: "#",
      },
    ],
  },
  legal: {
    page: {
      eyebrow: "Mentions légales",
      title: "Mentions légales",
      intro:
        "Informations légales relatives à l'éditeur, à l'hébergement et à l'utilisation du site 2amhospitality.com.",
      sections: [
        {
          title: "Éditeur du site",
          body: "2AM Hospitality\nFondateur : Alexandre Dufrene\nRue du Pachy 6, 1315 Incourt, Belgique\nEmail : hello@2amhospitality.com\nTéléphone : +32 479 89 52 15",
        },
        {
          title: "Directeur de la publication",
          body: "Alexandre Dufrene, en qualité de fondateur de 2AM Hospitality.",
        },
        {
          title: "Hébergement",
          body: "Le site est hébergé sur une infrastructure cloud edge (Cloudflare Workers). Les données applicatives sont hébergées sur l'infrastructure de Supabase (Union européenne).",
        },
        {
          title: "Propriété intellectuelle",
          body: "L'ensemble des contenus présents sur ce site (textes, visuels, logos, marques, structure) est la propriété exclusive de 2AM Hospitality, sauf mention contraire. Toute reproduction, représentation, modification ou diffusion, totale ou partielle, sans autorisation écrite préalable, est interdite.",
        },
        {
          title: "Responsabilité",
          body: "2AM Hospitality s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site, sans pouvoir en garantir l'exhaustivité. L'utilisateur reconnaît utiliser ces informations sous sa seule responsabilité.",
        },
        {
          title: "Liens externes",
          body: "Le site peut contenir des liens vers des sites tiers. 2AM Hospitality n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.",
        },
        {
          title: "Droit applicable",
          body: "Les présentes mentions légales sont régies par le droit belge. Tout litige relatif au site relève de la compétence exclusive des tribunaux de Bruxelles.",
        },
        {
          title: "Contact",
          body: "Pour toute question relative au site ou à ces mentions légales : hello@2amhospitality.com",
        },
      ],
    },
  },
  privacy: {
    page: {
      eyebrow: "Confidentialité",
      title: "Politique de confidentialité",
      intro:
        "Cette politique décrit comment 2AM Hospitality collecte, utilise et protège vos données personnelles, conformément au Règlement Général sur la Protection des Données (RGPD).",
      sections: [
        {
          title: "Responsable du traitement",
          body: "2AM Hospitality\nRue du Pachy 6, 1315 Incourt, Belgique\nContact : hello@2amhospitality.com",
        },
        {
          title: "Données collectées",
          body: "Nous collectons les données que vous nous transmettez via le formulaire de contact (nom, email, entreprise, type de demande, message) ainsi que des données techniques anonymisées de navigation (avec votre consentement, via Google Analytics).",
        },
        {
          title: "Finalités du traitement",
          body: "Vos données sont utilisées pour : répondre à vos demandes, organiser un échange ou un rendez-vous, assurer le suivi commercial de notre relation, mesurer l'audience du site (statistiques anonymisées) et respecter nos obligations légales.",
        },
        {
          title: "Base légale",
          body: "Le traitement repose sur votre consentement (formulaire, cookies de mesure d'audience), l'exécution de mesures précontractuelles à votre demande, et notre intérêt légitime à développer notre activité.",
        },
        {
          title: "Durée de conservation",
          body: "Les messages reçus via le formulaire sont conservés 3 ans à compter du dernier contact. Les données de mesure d'audience sont conservées 14 mois maximum. Le consentement aux cookies est conservé 12 mois.",
        },
        {
          title: "Destinataires",
          body: "Vos données sont accessibles à 2AM Hospitality uniquement. Elles peuvent être traitées par nos sous-traitants techniques (hébergement Supabase, envoi d'emails Resend, mesure Google Analytics), tous engagés contractuellement à respecter le RGPD.",
        },
        {
          title: "Transferts hors UE",
          body: "Certains sous-traitants (Google Analytics) peuvent impliquer des transferts hors Union européenne, encadrés par les clauses contractuelles types de la Commission européenne.",
        },
        {
          title: "Vos droits",
          body: "Conformément au RGPD, vous disposez des droits suivants : accès, rectification, effacement, limitation, opposition, portabilité, retrait du consentement à tout moment. Pour exercer ces droits : hello@2amhospitality.com.",
        },
        {
          title: "Réclamation",
          body: "Vous pouvez introduire une réclamation auprès de l'Autorité de protection des données (APD) belge : www.autoriteprotectiondonnees.be",
        },
        {
          title: "Sécurité",
          body: "Nous mettons en œuvre des mesures techniques et organisationnelles appropriées (chiffrement TLS, contrôle d'accès, sauvegardes) pour protéger vos données contre tout accès non autorisé, altération ou destruction.",
        },
      ],
    },
  },
  geo: "Interventions à Bruxelles, Anvers, Gand, Liège, Namur, Charleroi, Bruges, Louvain, Luxembourg-Ville et Esch-sur-Alzette — partout en Belgique et au Grand-Duché.",
};

export type Dict = typeof fr;

